import { put, call } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';

import { naturezasAPI } from 'services/apiRest';
import NaturezasActions from '../ducks/naturezas';

export function* getNaturezas() {
  try {
    const naturezas = yield call(naturezasAPI.listar);
    console.log('📥 [naturezasSaga] Naturezas recebidas da API:', {
      count: naturezas?.length || 0,
      naturezas: naturezas,
      isArray: Array.isArray(naturezas),
    });
    yield put(NaturezasActions.getNaturezasSuccess(naturezas));
  } catch (err) {
    console.error('❌ [naturezasSaga] Erro ao buscar naturezas:', err);
    yield put(NaturezasActions.getNaturezasFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro',
        message: 'Erro ao buscar naturezas',
      })
    );
  }
}

export function* addNatureza({ natureza, closeModal }) {
  try {
    const naturezaCriada = yield call(naturezasAPI.criar, natureza);
    yield put(NaturezasActions.addNaturezaSuccess(naturezaCriada));
    
    if (closeModal) closeModal();
    
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Natureza',
        message: 'Natureza criada com sucesso!',
      })
    );
  } catch (err) {
    console.error('Erro ao criar natureza:', err);
    yield put(NaturezasActions.addNaturezaFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro',
        message: 'Erro ao criar natureza',
      })
    );
  }
}

export function* updateNatureza({ natureza, closeModal }) {
  try {
    const naturezaAtualizada = yield call(
      naturezasAPI.atualizar,
      natureza.id,
      natureza
    );
    yield put(NaturezasActions.updateNaturezaSuccess(naturezaAtualizada));
    
    if (closeModal) closeModal();
    
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Natureza',
        message: 'Natureza atualizada com sucesso!',
      })
    );
  } catch (err) {
    console.error('Erro ao atualizar natureza:', err);
    yield put(NaturezasActions.updateNaturezaFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro',
        message: 'Erro ao atualizar natureza',
      })
    );
  }
}

export function* removeNatureza({ id }) {
  try {
    yield call(naturezasAPI.deletar, id);
    yield put(NaturezasActions.removeNaturezaSuccess(id));
    
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Natureza',
        message: 'Natureza excluída com sucesso!',
      })
    );
  } catch (err) {
    console.error('Erro ao excluir natureza:', err);
    yield put(NaturezasActions.removeNaturezaFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro',
        message: 'Erro ao excluir natureza',
      })
    );
  }
}

